export default {
    name: 'products',
    component(resolve) {
        require(['../components/pages/products/Show.vue'], resolve)
    },
    subRoutes: {
        '/stud-and-track-forming-machine': {
            component(resolve) {
                require(['../components/pages/products/sntfm.vue'], resolve)
            }
        },
        '/accessories': {
            component(resolve) {
                require(['../components/pages/products/Accessories.vue'], resolve)
            }
        },
        '/deck-roll-forming-machine': {
            component(resolve) {
                require(['../components/pages/products/DeckLines.vue'], resolve)
            }
        },
        '/folding-machine': {
            component(resolve) {
                require(['../components/pages/products/Folders.vue'], resolve)
            }
        },
        '/panel-roll-forming-machine': {
            component(resolve) {
                require(['../components/pages/products/PanelLines.vue'], resolve)
            }
        },
        '/cu-purlin-roll-forming-machine': {
            component(resolve) {
                require(['../components/pages/products/CuPurlinLines.vue'], resolve)
            }
        },
        '/cz-purlin-roll-forming-machine': {
            component(resolve) {
                require(['../components/pages/products/CzPurlinLines.vue'], resolve)
            }
        },
        '/ridgecap-roll-forming-machine': {
            component(resolve) {
                require(['../components/pages/products/RidgeCapLines.vue'], resolve)
            }
        },
        '/tile-roll-forming-machine': {
            component(resolve) {
                require(['../components/pages/products/TileLines.vue'], resolve)
            }
        },
        '/tube-roll-forming-machine': {
            component(resolve) {
                require(['../components/pages/products/TubeLines.vue'], resolve)
            }
        },
        '/roof-panel-forming-machine': {
            component(resolve) {
                require(['../components/pages/products/RPFM.vue'], resolve)
            }
        }
        /*,
        '/pbsm/prod01': {
            component(resolve) {
                require(['../components/pages/products/pbsm/Prod01.vue'], resolve)
            }
        },
        '/pbsm/prod02': {
            component(resolve) {
                require(['../components/pages/products/pbsm/Prod02.vue'], resolve)
            }
        },
        '/pbsm/prod03': {
            component(resolve) {
                require(['../components/pages/products/pbsm/Prod03.vue'], resolve)
            }
        },
        '/pbsm/prod04': {
            component(resolve) {
                require(['../components/pages/products/pbsm/Prod04.vue'], resolve)
            }
        },
        '/pbsm/prod05': {
            component(resolve) {
                require(['../components/pages/products/pbsm/Prod05.vue'], resolve)
            }
        }*/
    }
}


// WEBPACK FOOTER //
// ./src/routermappings/products_rm_config.js